import {
    HStack,
    VStack,
    Progress,
    Skeleton,
    SkeletonCircle,
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useSelector } from 'react-redux';
import { Card, CardBody } from 'components/v4/Card';
import styles from '../styles';

const skeletonCardEntrance = keyframes`
    0% {
        opacity: 0;
        transform: translateY(10px) scale(0.985);
    }

    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
`;

const skeletonCardFloat = keyframes`
    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-3px);
    }
`;

const DashboardHydrationCardSkeleton = ({ animationDelayMs = 0 }) => {
    const { darkMode } = useSelector((state) => state.settings);

    const skeletonStartColor = darkMode ? 'whiteAlpha.200' : 'gray.100';
    const skeletonEndColor = darkMode ? 'whiteAlpha.300' : 'gray.300';
    const entranceDelay = `${animationDelayMs}ms`;
    const floatDelay = `${animationDelayMs + 260}ms`;

    return (
        <Card
            bg={darkMode ? 'dark.tcap' : null}
            sx={{
                ...styles.serviceCard,
                border: '1px solid',
                borderColor: darkMode ? 'gray.700' : 'gray.200',
                boxShadow: darkMode
                    ? 'none'
                    : '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                opacity: 0,
                transform: 'translateY(10px) scale(0.985)',
                animation: `${skeletonCardEntrance} 320ms ease-out ${entranceDelay} both, ${skeletonCardFloat} 2200ms ease-in-out ${floatDelay} infinite`,
            }}>
            <Progress
                value={100}
                sx={styles.verticalBar}
                colorScheme="gray"
                isIndeterminate
            />
            <CardBody
                sx={{
                    display: 'flex',
                    flexDir: 'column',
                    ...styles.serviceCardBody,
                }}>
                {/* (3158) Same size as the compact card it stands in for. */}
                <HStack alignItems="flex-start" width="100%" spacing={3}>
                    <SkeletonCircle
                        size="30px"
                        startColor={skeletonStartColor}
                        endColor={skeletonEndColor}
                    />
                    <VStack alignItems="flex-start" width="100%" spacing={2}>
                        <Skeleton
                            height="18px"
                            width="160px"
                            startColor={skeletonStartColor}
                            endColor={skeletonEndColor}
                        />
                        <Skeleton
                            height="14px"
                            width="110px"
                            startColor={skeletonStartColor}
                            endColor={skeletonEndColor}
                        />
                    </VStack>
                </HStack>
            </CardBody>
        </Card>
    );
};

export default DashboardHydrationCardSkeleton;
